export var ADD_SMS = '[Sms] Add';
export var ADD_SMS_SUCCESS = '[Sms] Add Success';
export var ADD_SMS_ERROR = '[Sms] Add Error';
var AddSms = /** @class */ (function () {
    function AddSms(payload) {
        this.payload = payload;
        this.type = ADD_SMS;
    }
    return AddSms;
}());
export { AddSms };
var AddSmsSuccess = /** @class */ (function () {
    function AddSmsSuccess(payload) {
        this.payload = payload;
        this.type = ADD_SMS_SUCCESS;
    }
    return AddSmsSuccess;
}());
export { AddSmsSuccess };
var AddSmsError = /** @class */ (function () {
    function AddSmsError(payload) {
        this.payload = payload;
        this.type = ADD_SMS_ERROR;
    }
    return AddSmsError;
}());
export { AddSmsError };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/store/actions/sms-blast.action.ts.pre-build-optimizer.js